import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/accessService";
const store = {};
const mutations = {
    GET_ACCESS_LIST(state, posts) {
        var result = {};
        posts.accessList.forEach(m => result["_" + m] = true);
        // Merge new flags with existing ones so multiple parallel calls union their permissions, currently set permissions are never removed because the server doesn't send that info
        state.accessList = { ...(state.accessList || {}), ...result };
    },
    GET_PROFILES_INFO(state, posts) {
        const res = posts.result
        state.profilesInfo = res;
        if (res && res.length > 0) {
            var mentorProfile = res.find(m => m.TtyId == 24 && m.StgId == 15);
            if (mentorProfile) {
                state.hasPublishedMentorProfile = true;
            }
            else {
                state.hasPublishedMentorProfile = false;
            }
        }
        else {
            state.hasPublishedMentorProfile = false;
        }
        if (res && res.length > 0) {
            var participantProfile = res.find(m => m.TtyId == 22 && m.StgId == 15);
            if (participantProfile) {
                state.hasPublishedParticipantProfile = true;
            }
            else {
                state.hasPublishedParticipantProfile = false;
            }
        }
        else {
            state.hasPublishedParticipantProfile = false;
        }
    },
};
const state = {
    // Keep as object; keys are like _300421: true
    accessList: {},
    profilesInfo: [],
    hasPublishedMentorProfile: false,
    hasPublishedParticipantProfile: false,
};
const getters = {};
const actions = {
    getProfilesInfo({ commit }) {
        return axios
            .get(baseUri + '/GetProfilesInfo')
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_PROFILES_INFO', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    getAccessList({ commit }, { tokenList }) {
        var formData = new FormData();
        formData.append("args", JSON.stringify({ tokenList }));
        return axios
            .post(baseUri + '/GetAccessList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_ACCESS_LIST', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}